import styled from 'styled-components'
import size from '../../../styled/sizes'
import fonts from '../../../styled/fonts'

export const TabsContainer = styled.div`
        display: flex;
        flex-direction: row;
        margin-bottom: 15px;
        width: 100%;
        @media (max-width: ${size.breakPoints.small}) {
           width: 100%;
           display: flex;
           justify-content: center;
        }
`


export const TabButton = styled.button`
        min-width: 140px;
        text-align: left;
	padding: 9px 16px;
	border: none;
	background: transparent;
	cursor: pointer;
	font-size: 14px;
	font-weight: ${props => (props.$active ? fonts.fontWeight.semibold : fonts.fontWeight.regular)};
	color: ${props =>
		props.$active ? props.theme.colors.text.titleText : props.theme.colors.text.mutedText};
	border-bottom: ${props => (props.$active ? '2px' : '1px')} solid ${props => (props.$active ? props.theme.colors.brand.lightBlue : props.theme.colors.greys.dividerGray)};
	margin-bottom: -1px;
	transition: color 0.2s ease, border-color 0.2s ease;
        @media (max-width: ${size.breakPoints.small}) {
          width: 100%;
          text-align: center;
        }
`
